import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=7ee59382&"
import script from "./loader.vue?vue&type=script&lang=js&"
export * from "./loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Devdoc\\_packages\\moss-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ee59382')) {
      api.createRecord('7ee59382', component.options)
    } else {
      api.reload('7ee59382', component.options)
    }
    module.hot.accept("./loader.vue?vue&type=template&id=7ee59382&", function () {
      api.rerender('7ee59382', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/loader.vue"
export default component.exports